module.exports = __webpack_public_path__ + "img/2-2.971f16c6.png";